module.exports = __webpack_public_path__ + "img/s2.cfba06b7.png";